export default function buddies(state = '', action){
  if (action.type === 'buddies') {
    return state = action.buddies;
  } else {
    return state;
  }
}
